let zIndex = 20141223
export const getZIndex = function () {
  return zIndex++
}



/** WEBPACK FOOTER **
 ** ./src/utils/index.js
 **/